<template>
  <el-dialog :title="this.statusPagamento === 'PAGO' ? 'Pagar Aluguel' : 'Pagar Aluguel Parcialmente'" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">                  
        <el-col :span="6">
          <el-form-item label="Data Vencimento">
            <div class="el-input el-input--small" >
              <span
                readonly
                style="cursor: unset; background-color: #f5f7fa;"
                class="el-input__inner"
              >{{reciboRecuperado.dataVencimento}}</span>
            </div>
          </el-form-item>
        </el-col>  

        <el-col :span="6">
          <el-form-item label="Data Pagamento">
            <el-date-picker v-model="dataPagamento" :disabled="desabilitarDataPagamento" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>          
        <el-col :span="6">
          <el-button @click="calcularAluguelHandler" type="primary" size="small" style="margin-top:17px;" round class="btn-box-shadow">Calcular</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Valor Calculado">
            <div class="el-input el-input--small" >
              <money
                v-model="valorPagamento"
                v-bind="money"
                readonly
                style="cursor: unset; background-color: #f5f7fa;"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Valor do Pagamento">
            <money auto-complete="off" v-model="reciboRecuperado.valorPagamento" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Recebido através de " prop="formaRecebimento">
            <el-select v-model="reciboRecuperado.formaRecebimento" clearable :disabled="desabilitarFormaRecebimento" value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in formasRecebimento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="boleto">
        <el-col :span="6">
          <el-form-item label="Data Crédito">
            <el-date-picker v-model="reciboRecuperado.dataCreditoPagamento" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="transferenciaBancaria">
        <el-col :span="10">
          <el-form-item label="Conta Bancária da Imobiliária">
            <el-input size="small" v-model="labelContaBancariaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button @click="exibirSelecionarContaBancariaDialog" type="primary" icon="el-icon-search" size="small" style="margin-top: 17px" circle class="btn-box-shadow"/>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="reciboRecuperado.itensRecibo"
            empty-text="Nenhum item encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Tipo" prop="tipo" width="150" :formatter="labelTipoRecibo"/>
            <el-table-column label="Descrição" prop="nome"/>
            <el-table-column label="Valor" prop="valor" :formatter="labelValor" width="130"/>
            <el-table-column width="90" column-key="acoes">
              <template slot-scope="scope" v-if="(scope.row.categoria === 'DESCONTO')">
                <el-button @click.native.prevent="removerDesconto(scope.$index,reciboRecuperado.itensRecibo)" type="text" size="small" style="padding: 0px; color: #F56C6C;">Remover</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 10px" v-if="totalEncargos > 0">
        <el-col :span="12" style="margin-top: 17px">
          {{"Total dos Encargos " + this.formatarValor(this.totalEncargos)}}
        </el-col>
        <el-col :span="12">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item label="Desconto">
                <money auto-complete="off" v-model="desconto" v-bind="money" :disabled="desabilitarDesconto" class="el-input__inner"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label=" ">
                <el-button @click="concederDesconto" type="primary" size="small" style="width: 100%" :disabled="desabilitarDesconto" round class="btn-box-shadow">Conceder</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
        <el-button @click="pagarBoletoHandler" type="primary" size="small" round class="btn-box-shadow">Pagar Recibo</el-button>
    </span>
  
    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaDialog" :cliente="undefined" v-if="reciboRecuperado" :visibility="visibilidadeSelecionarContaBancariaDialog" todosOsBancos/>
    <app-detalhes-lancamento-caixa-dialog @close="fecharDetalhesLancamentoCaixaDialog" @pagarAluguel="pagarNaImobiliaria" :recibo="reciboRecuperado" tipoRecibo="ALUGUEL" :totalDoAluguel="reciboRecuperado.valorPagamento" v-if="reciboRecuperado" :visibility="visibilidadeDetalhesLancamentoCaixaDialog"/>
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { FORMA_RECEBIMENTO, TIPO_ITEM_RECIBO } from '../../../util/constantes.js';
import { Money } from "v-money";
var BigDecimal = require("js-big-decimal");

import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue';  
import AppDetalhesLancamentoCaixaDialog from '../../../shared/dialogs/DetalhesLancamentoCaixaDialog.vue';  

export default {
  //statusPagamento DEFINE COMO SERA FEITO O PAGAMENTO: PARCIAL OU TOTAL (MANTER RECIBO EM ABERTO OU PAGO)
  props: {
    statusPagamento: String, 
    recibo: Object,
    visibility: Boolean,
    formaRecebimentoInicial: String
  },
  components: {
    AppSelecionarContaBancariaDialog,
    AppDetalhesLancamentoCaixaDialog,

    Money
  },
  created(){
    if(this.recibo.dataProrrogacao){
      this.dataPagamento = this.recibo.dataProrrogacao
    } else {
      this.dataPagamento = Util.hoje()      
      }
    this.calcularAluguelHandler()
  },
  data() {
    return {
      reciboRecuperado: {
        dataProrrogacao: Util.hoje(),
        itensRecibo: []
      },

      dataPagamento: Util.hoje(),
      calculado: false,
      desconto: 0,
      valorPagamento: undefined,
      contaBancaria: {
        id: 0,
        nome: ''
      },

      validacao: {
        formaRecebimento: [
          { type: "string", required: true }
        ]
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      visibilidadeSelecionarContaBancariaDialog: false,
      visibilidadeDetalhesLancamentoCaixaDialog: false
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    formasRecebimento() {
      return FORMA_RECEBIMENTO;
    },
    tipoItem() {
      return TIPO_ITEM_RECIBO;
    },
    desabilitarDataPagamento() {
      return (this.reciboRecuperado && this.reciboRecuperado.dataProrrogacao) ? true : false
    },
    desabilitarFormaRecebimento() {
      return !this.permissoes.alterarFormaPagamentoAluguel
    },
    desabilitarDesconto(){
      return !this.permissoes.concederDescontoPagarAluguel
    },
    totalEncargos() {
      let total = 0
      
      this.reciboRecuperado.itensRecibo.forEach(item => {
        if(this.isEncargo(item)) {
          total += item.valor
        }
      });

      return total;
    },
    boleto() {
      return (this.reciboRecuperado.formaRecebimento == "BOLETO")
    },
    transferenciaBancaria() {
      return (this.reciboRecuperado.formaRecebimento == "TRANSFERENCIA_BANCARIA")
    },
    pagoNaImobiliaria() {
      return (this.reciboRecuperado.formaRecebimento == "CAIXA_DA_IMOBILIARIA")
    },
    cartaoDeCredito() {
      return (this.reciboRecuperado.formaRecebimento == "CARTAO_DE_CREDITO")
    },
    acordo() {
      return (this.reciboRecuperado.formaRecebimento == "ACORDO")
    },
    contaBancariaNaoSelecionada() {
      return (!this.contaBancaria || (this.contaBancaria && this.contaBancaria.id === 0));
    },
    loading() {
      return this.$store.state.loading;
    },
    labelContaBancariaImobiliaria() {
      return `${this.contaBancaria.nome ? this.contaBancaria.nome : ''} ${this.contaBancaria.conta ? '- Conta: ' + this.contaBancaria.conta : ''}${this.contaBancaria.digitoConta ? '-' + this.contaBancaria.digitoConta : '' }`
    }
  },
  watch:{
    dataPagamento: function (newValue, oldValue) {
      if(newValue != oldValue){
        this.calculado = false
      }
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'calcularAluguelCliente',
        'listarContasBancariasCliente',
        'pagarRecibo'
    ]),
    iniciar() {
      if(this.recibo.dataProrrogacao){
        this.dataPagamento = this.recibo.dataProrrogacao
      } else {
        this.dataPagamento = Util.hoje()
      }
      this.calcularAluguelHandler()
    },
    calcularAluguelHandler() {
      if(!this.dataPagamento) {
        this.$message.warning("Insira a data de Pagamento!");
        return;
      }

        let payload = { id: this.recibo.id, dataPagamento: this.dataPagamento }

        this.showLoading();
        this.calcularAluguelCliente(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.reciboRecuperado = resultado.item
                    if(this.formaRecebimentoInicial) {
                      this.reciboRecuperado.formaRecebimento = this.formaRecebimentoInicial;
                    }
                    this.valorPagamento = resultado.item.valorPagamento;
                    if(this.statusPagamento === 'EM_ABERTO'){
                      this.reciboRecuperado.valorPagamento = undefined;
                    }
                    this.calculado = true;
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },
    pagarBoletoHandler() {
      const descontoConcedidoPeloUsuario = this.reciboRecuperado.itensRecibo.filter(item => {
        return item.categoria === 'DESCONTO'
          && item.nome !== 'Desconto por antecipação';
      })[0];

      const valorDesconto = new BigDecimal(descontoConcedidoPeloUsuario ? descontoConcedidoPeloUsuario.valor : 0).round(2, BigDecimal.RoundingModes.HALF_UP);
      const valorTotalEncargos = new BigDecimal(this.totalEncargos).round(2, BigDecimal.RoundingModes.HALF_UP);
      
      const descontoMaiorQueEncargos = valorDesconto.compareTo(valorTotalEncargos) === 1;
      if(descontoMaiorQueEncargos) {
        this.$message.warning('Desconto não pode ser maior que o valor dos encargos!');
        return;
      }

      if(this.reciboRecuperado.formaRecebimento === 'BOLETO' && this.reciboRecuperado.aluguel.contaBancariaImobiliaria.banco === undefined){
         this.$message.warning("Contrato de aluguel não possui Conta Bancária cadastrada!");
         return;
       }

      if(this.pagoNaImobiliaria) {
        this.exibirDetalhesLancamentoCaixaDialog();
      } else {
        this.pagar();
      }
    },

    pagarNaImobiliaria(detalhesLancamento) {
      this.visibilidadeDetalhesLancamentoCaixaDialog = false
      this.reciboRecuperado.lancamentoCaixa = {}
      this.reciboRecuperado.lancamentoCaixa.detalhesLancamento = detalhesLancamento;
      this.pagar()
    },

    pagar() {
      if(this.dadosValidos()){
        this.reciboRecuperado.status = this.statusPagamento; //DEFINE SE O PAGAMENTO SERÁ PARCIAL OU TOTAL
        this.reciboRecuperado.encargos = this.totalEncargos;
        this.reciboRecuperado.dataPagamento = this.dataPagamento;
        this.reciboRecuperado.valorEmAberto = this.valorPagamento;
        
        this.reciboRecuperado.desconto = {
          valor: this.desconto
        }
        
        if(!this.boleto) {
          this.reciboRecuperado.dataCreditoPagamento = this.reciboRecuperado.dataPagamento
        }

        if(this.transferenciaBancaria) {
          this.reciboRecuperado.contaBancaria = this.contaBancaria
        } else {
          delete this.reciboRecuperado.contaBancaria;
        }
        
        if(this.pagoNaImobiliaria) {
          this.reciboRecuperado.lancamentoCaixa.operacao = 'ENTRADA';
          this.reciboRecuperado.lancamentoCaixa.descricao = 'Pagamento de Aluguel';
          this.reciboRecuperado.lancamentoCaixa.valor = this.reciboRecuperado.valorPagamento;
        }
        
        this.showLoading();
        this.pagarRecibo(this.reciboRecuperado)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.concluirPagamento(resultado);
                    break;
                case "FALHA":
                    this.exibirAlert("Atenção", resultado.mensagem);	
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
      } else {
        if(!this.calculado) {
          this.exibirAlert("Atenção", "Você deve calcular o valor do pagamento antes de dar baixa no pagamento");	
        } else if(this.statusPagamento === 'EM_ABERTO' && this.reciboRecuperado.valorPagamento >= this.valorPagamento){
          this.exibirAlert("Atenção", "O valor do pagamento parcial não dever ser maior ou igual ao valor do recibo.")
        }else if(this.statusPagamento === 'EM_ABERTO' && this.reciboRecuperado.valorPagamento === 0){
          this.exibirAlert("Atenção", "O valor do pagamento parcial não dever ser Zero.")
        } else if(this.boleto) {
          this.exibirAlert("Atenção", "Digite a data de crédito do boleto");
        } else if(this.transferenciaBancaria && this.contaBancariaNaoSelecionada) {
          this.exibirAlert("Atenção", "Selecione a conta bancária da imobiliária");
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      }
    },
    
    dadosValidos() {
      var validacao = true;
      
      validacao = this.calculado && validacao;
      validacao = this.reciboRecuperado.formaRecebimento && validacao;
      
      if(this.boleto) {
        validacao = this.reciboRecuperado.dataCreditoPagamento && validacao;
      }
      
      if(this.transferenciaBancaria && this.contaBancariaNaoSelecionada) {
        validacao = false;
      }

      if(this.statusPagamento === 'EM_ABERTO' && (this.reciboRecuperado.valorPagamento >= this.valorPagamento ||
      this.reciboRecuperado.valorPagamento === 0)){
        validacao = false;
      }
      
      return validacao;
    },

    isEncargo(itemRecibo) {
      return itemRecibo.categoria == "MULTA"
        || itemRecibo.categoria == "JUROS"
        || itemRecibo.categoria == "PERMANENCIA_DIARIA"
        || itemRecibo.categoria == "HONORARIOS_ADVOCATICIOS"
    },
    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    concederDesconto(){
      this.reciboRecuperado.itensRecibo = this.reciboRecuperado.itensRecibo.filter(item => { return item.categoria !== "DESCONTO" });

      if(this.desconto > 0){
        this.reciboRecuperado.itensRecibo.push(this.criarItemDesconto());
      }
      this.recalcularValorRecibo()
    },

    removerDesconto(index, rows){
      rows.splice(index,1);
      this.recalcularValorRecibo()
      this.desconto = 0;
    },

    criarItemDesconto(){
      let itemDesconto = {
        nome: "Desconto - Pagamento do Aluguel",
        dataMovimento: this.reciboRecuperado.dataPagamento,
        valor: this.desconto,
        tipo: "CREDITO",
        categoria: "DESCONTO"
      }

      return itemDesconto
    },
    recalcularValorRecibo() {
      let total = 0.0;
      this.reciboRecuperado.itensRecibo.forEach(item => {
        if(item.tipo === "DEBITO"){
          total += item.valor;
        } else if(item.tipo === "CREDITO") {
          total -= item.valor;
        }
      });
      this.valorPagamento = total;
      //SE NAO PAGAMENTO PARCIAL, ATRIBUE O MESMO VALOR CALCULADO AO VALOR PAGAMENTO
      if(this.statusPagamento === 'PAGO'){
        this.reciboRecuperado.valorPagamento = total;
      } 
    },

    exibirSelecionarContaBancariaDialog() {
        this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id !== 0){
        this.contaBancaria = contaBancaria
      }
      this.visibilidadeSelecionarContaBancariaDialog = false;
    },

    exibirDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = true
    },
    fecharDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = false
    },

    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    labelTipoRecibo(item){
      return Util.getLabel(this.tipoItem,item.tipo)
    },
    labelValor(item) {
      return Util.formatarValor(item.valor)
    },
    reset(){
      this.reciboRecuperado = {
        dataProrrogacao: Util.hoje(),
        itensRecibo: []
      },

      this.calculado = false,
      this.desconto = 0,
      this.valorPagamento = undefined,
      this.contaBancaria = {
        id: 0,
        nome: ''
      }
    },
    concluirPagamento(resultado) {
      this.reset();
      this.$emit('concluirPagamento',resultado);
    },
    fechar() {
      this.reset();
      this.$emit('close');
    } 
  }
}
</script>
